import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import {Player} from '../../shared/models/player';
import {SelectedPlayers} from '../models/player-filter';

export const resetActivationCodeActionTypes = {
  RESET: type('[Player] RESET Activation code'),
  RESET_SUCCESS: type('[Player] RESET Activation code Success'),
  RESET_FAIL: type('[Player] RESET Activation code Fail'),
};

export class ResetActivationCodeAction implements Action {
  readonly type = resetActivationCodeActionTypes.RESET;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any ) {}
}

export class ResetActivationCodeSuccessAction implements Action {
  readonly type = resetActivationCodeActionTypes.RESET_SUCCESS;
  constructor(public payload?: ArrayResponse<Player>) {}
}

export class ResetActivationCodeFailAction implements Action {
  readonly type = resetActivationCodeActionTypes.RESET_FAIL;
  constructor(public payload?: string) {}
}

